/*
 * Registers public/sw.js, which caches book photos by S3 path so a re-signed
 * URL does not force a re-download. Silently does nothing where service
 * workers are unavailable (WKWebView inside the native app, insecure
 * origins) — the page then loads exactly as before.
 */
export function registerImageCacheWorker() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return;
  }
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;
  const url = `${process.env.PUBLIC_URL || ""}/sw.js`;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(url).catch((error) => {
      console.warn("Image cache worker registration failed:", error);
    });
  });
}
